/**
 * "Discarded" is a terminal work log status for empty, auto-submitted work logs.
 * It is not part of the SDK `WorkLogStatus` enum yet, so it is represented as a
 * string constant and compared via a cast at the boundaries that need it.
 *
 * TODO(v3): remove this once the backend adds `Discarded` to `WorkLogStatus`.
 */
export const WORK_LOG_STATUS_DISCARDED = "Discarded" as const;
